(function(){
  var TZ='America/Santiago';
  function wd(d){var s=new Intl.DateTimeFormat('en-US',{timeZone:TZ,weekday:'short'}).format(d);return {Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[s];}
  function fmt(d){return new Intl.DateTimeFormat('es-CL',{timeZone:TZ,weekday:'long',day:'numeric',month:'long'}).format(d);}
  function nextDispatch(days){
    var now=new Date(),today=wd(now);
    for(var i=1;i<=7;i++){if(days.indexOf((today+i)%7)>-1){return new Date(now.getTime()+i*864e5);}}
    return null;
  }
  function fillNext(){
    document.querySelectorAll('[data-cod-next]').forEach(function(el){
      var days=(el.getAttribute('data-days')||'2,4,6').split(',').map(Number);
      var d=nextDispatch(days); if(d){el.textContent=fmt(d);}
    });
  }
  function pad(n){return n<10?'0'+n:''+n;}
  function tick(){
    document.querySelectorAll('[data-cod-deadline]').forEach(function(box){
      var end=new Date(box.getAttribute('data-cod-deadline')+'T23:59:59-03:00').getTime();
      var left=end-Date.now();
      var wrap=box.closest('[data-cod-deadline-wrap]')||box;
      if(isNaN(end)||left<=0){wrap.hidden=true;return;}
      wrap.hidden=false;
      var d=Math.floor(left/864e5),h=Math.floor(left/36e5)%24,m=Math.floor(left/6e4)%60,s=Math.floor(left/1e3)%60;
      var set=function(k,v){var n=box.querySelector('[data-u="'+k+'"]');if(n)n.textContent=v;};
      set('d',d);set('h',pad(h));set('m',pad(m));set('s',pad(s));
    });
  }
  function init(){fillNext();tick();setInterval(tick,1000);}
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
  document.addEventListener('shopify:section:load',function(){fillNext();tick();});
})();
